/**
 * Rango ini/fin (formato "yyyy-MM-ddTHH:mm:ss") de un mes completo.
 * Si no se envia anio/mes se usa el mes actual.
 */
export function getRangoMes(anio, mes) {
  const hoy = new Date();
  const anioFiltro = anio || hoy.getFullYear();
  const mesFiltro = mes || hoy.getMonth() + 1; // 1 (enero) - 12 (diciembre)
  const mesStr = String(mesFiltro).padStart(2, "0");
  const ultimoDia = new Date(anioFiltro, mesFiltro, 0).getDate();

  return {
    ini: `${anioFiltro}-${mesStr}-01T00:00:00`,
    fin: `${anioFiltro}-${mesStr}-${String(ultimoDia).padStart(2, "0")}T23:59:59`,
  };
}
